import app from '../../scripts/app';
const templates = require.context('./templates', true, /\.tpl\.jade$/);
templates.keys().map(templates);

app.directive('cianAfHeaderPromo', [() => {
    return {
      scope: {},
      bindToController: {},
      controllerAs: 'headerPromoCtrl',
      template: '<ng-include src="headerPromoCtrl.getTemplateUrl()"/>',
      controller: function(addFormConfig, headerPromoService) {
        'ngInject';

        this.getPromoImagePath = addFormConfig.imagesPath + 'header-promo/';

        this.getTemplateUrl = function() {
          return "blocks/header-promo/templates/" + headerPromoService.getType() + ".tpl.jade";
        };

        this.handleCloseButtonClick = () => {
          headerPromoService.isVisible = false;
        };
      },
    };
  }]);
